import React, { useState, useRef, useEffect } from 'react';

import { DiffContent } from '@atlassian/bitkit-diff';

import { CodemirrorDiffEditorLite } from './codemirror-diff-editor-lite';
import { getDiffContentWithoutPrefix, getDiffStartLineNum } from './utils';

interface CodeSuggestionEditorProps {
  diffLine: DiffContent;
  nodeLocalId: string;
  saveSuggestion: (suggestion: Record<string, string>) => void;
  suggestionText?: string;
}

export const CodeSuggestionEditor = React.memo(function CodeSuggestionEditor({
  diffLine,
  nodeLocalId,
  saveSuggestion,
  suggestionText,
}: CodeSuggestionEditorProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const originalCode = getDiffContentWithoutPrefix(diffLine);
  // determine the initial suggestion based on whether it's in edit or create mode
  const initialSuggestion =
    suggestionText !== undefined ? suggestionText : originalCode;
  const [currentSuggestion, setCurrentSuggestion] = useState(initialSuggestion);

  // save the suggestion when the component mounts
  useEffect(() => {
    saveSuggestion({ [nodeLocalId]: currentSuggestion });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSuggestionChange = (newSuggestion: string) => {
    setCurrentSuggestion(newSuggestion);

    saveSuggestion({ [nodeLocalId]: newSuggestion });
  };

  return (
    <div ref={wrapperRef}>
      <CodemirrorDiffEditorLite
        startLineNum={getDiffStartLineNum(diffLine)}
        originalCode={originalCode}
        updatedCode={currentSuggestion}
        onChange={handleSuggestionChange}
        nodeLocalId={nodeLocalId}
      />
    </div>
  );
});
